import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface DialogContentProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const DialogContent: React.FC<DialogContentProps> = ({ children, style }) => {
  return <Content style={style}>{children}</Content>;
};

export default DialogContent;

const Content = styled.div`
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 1rem;
  color: #333;
`;
